import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Message } from 'semantic-ui-react'
import { useAuth } from 'context/user'
import {
    HOME_DASHBOARD_SETTINGS_TAB,
    dismissHomeBanner,
    isHomeBannerDismissed,
    isHomeDashboardAdmin,
    isHomeDashboardEligible,
    useHomeDashboardStatus,
} from 'utility/home-dashboard'

// Shown on the task list to company admins whose company is still on the classic layout and may
// switch (the backend gate allows it). Dismissed per company in this browser. Renders nothing for
// Cintas, franchise users, non-admins and companies already on the new home.
export const HomeDashboardBanner = () => {
    const { user } = useAuth()
    const navigate = useNavigate()
    const relevant = isHomeDashboardEligible(user) && isHomeDashboardAdmin(user)
    const status = useHomeDashboardStatus(relevant ? user : null)
    const [hidden, setHidden] = useState(() => isHomeBannerDismissed(user))

    if (!relevant || hidden || !status?.available || status.layout !== 'classic' || !status.canEdit) {
        return null
    }

    return (
        <Message
            info
            onDismiss={() => {
                dismissHomeBanner(user)
                setHidden(true)
            }}
            style={{ marginBottom: 16 }}
        >
            <Message.Header>Try the new home dashboard</Message.Header>
            <p style={{ margin: '4px 0 0' }}>
                One page with your scores or findings, site health, overdue audits, tickets and what needs a
                decision. It adapts to how your company works, and you can
                switch back to this page at any time.{' '}
                <button
                    type="button"
                    onClick={() => navigate(`/app/settings/${HOME_DASHBOARD_SETTINGS_TAB}`)}
                    style={{
                        background: 'none',
                        border: 0,
                        padding: 0,
                        color: '#1e44b8',
                        fontWeight: 600,
                        cursor: 'pointer',
                    }}
                >
                    Turn it on in Settings
                </button>
            </p>
        </Message>
    )
}
